import React from "react";

/**
 * Bandeau « Impact Score » de l'accueil, sous les 4 cartes « Notre identité »
 * (Lucas, 26/10/2026 : « un long rectangle sous les 4 encarts, pas gros »,
 * puis « tu dois utiliser la vignette, pas une reproduction »).
 *
 * Vignette = le badge OFFICIEL remis par Impact Score à Gively
 * (`public/impact-score-badge.png`, réduit à 192 px) : version « 73 » remise par
 * Lucas le 27/10/2026, cohérente avec le score détaillé « 73,45 / 100 — Évalué
 * le 26/10/2026 » que donne le texte.
 *
 * Méthode, d'après la page officielle https://www.impactscore.fr/tout-comprendre
 * (lue le 26/10/2026) : trois piliers comptant chacun pour 1/3 de la note ;
 * l'outil « ne constitue ni une certification, ni une garantie de performance,
 * ni une reconnaissance officielle ».
 */
export const IMPACT_SCORE = {
  valeur: "73,45",
  sur: 100,
  evalueLe: "26/10/2026",
  badge: "/impact-score-badge.png",
  source: "https://www.impactscore.fr/tout-comprendre",
};

export const PILIERS = ["impacts négatifs", "partage de la valeur", "stratégie à impact"];

export default function ImpactScoreEncart() {
  return (
    <a
      href={IMPACT_SCORE.source}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="impact-score-encart"
      className="mt-3 sm:mt-4 flex items-center gap-3 rounded-2xl border border-emerald-100 bg-white/80 px-3 py-2.5 hover:shadow-md transition-shadow"
    >
      <img
        src={IMPACT_SCORE.badge}
        alt="Badge Impact Score de Gively"
        width="56"
        height="56"
        loading="lazy"
        decoding="async"
        className="w-14 h-14 flex-shrink-0"
      />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-bold text-slate-900 leading-tight">
          Impact Score : <span className="text-emerald-700">{IMPACT_SCORE.valeur}/{IMPACT_SCORE.sur}</span>
        </p>
        <p className="text-[11.5px] sm:text-xs text-slate-600 leading-snug">
          Auto-évaluation Mouvement Impact France du {IMPACT_SCORE.evalueLe} : 3 piliers
          ({PILIERS.join(", ")}). Ni certification ni label officiel.
        </p>
      </div>
      <span className="text-lg text-slate-400 flex-shrink-0" aria-hidden="true">›</span>
    </a>
  );
}
